<template>
  <div>
    <vx-card title="Action History" class="mb-base">
      <div class="vx-row mt-4">
        <div class="vx-col sm:w-1/1 w-full mb-4">
          <vs-table
            pagination
            max-items="5"
            :data="data"
            :stripe="true"
            v-if="data != null"
          >
            <template slot="thead">
              <vs-th sort-key="EventName">Event</vs-th>
              <vs-th sort-key="Message">Message</vs-th>
              <vs-th sort-key="ActionBy">Action By</vs-th>
              <vs-th sort-key="ActionDate">Action Date</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <!-- <vs-td :data="indextr">
                  {{ indextr }}
                </vs-td> -->
                <vs-td :data="data[indextr].eventName">
                  {{ data[indextr].eventName }}
                </vs-td>
                <vs-td :data="data[indextr].message">
                  {{ data[indextr].message }}
                </vs-td>
                <vs-td :data="data[indextr].actionBy">
                  {{ data[indextr].actionBy }}
                </vs-td>
                <vs-td :data="data[indextr].actionDate">
                  {{ format(data[indextr].actionDate) }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <pre v-if="data == null">No data Available.</pre>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { _historyservices } from "../../services/historyservices";
import { dateFormat } from "../../services/utility";

export default {
  data() {
    return {
      data: [],
    };
  },
  created() {
    this.getHistory();
  },
  methods: {
    async getHistory() {
      this.data = await _historyservices.GetHistoryByVendorID(
        this.$route.params.id
      );
      // console.log(this.data);
    },

    format(date) {
      if (date != null) return dateFormat(date);

      return null;
    },
  },
};
</script>

<style lang="scss" scoped></style>
